import {
  IReports,
  type XZReport,
} from "@/androidPlugins/IReports"
import { getDoubleDataLine } from "@/utils/printing"

const { formatToMerchantCurrencyString } = useCurrency()

export const formatEvoPaymentsZReport = async (
  report: XZReport
) => {
  const { name, address1, address2 } = useTenant()

  let merchantId: string | null = null

  try {
    const { value } = await IReports.getReportMerchantId()
    merchantId = value
  } catch {
    toast.error("Error fetching MID")
    merchantId = "UNKNOWN"
  }

  const headerFields = report.headerFields ?? {}

  const headerString =
    name.value +
    "\n" +
    (address1.value ? address1.value + "\n" : "") +
    (address2.value ? address2.value + "\n" : "") +
    getDataLine(merchantId, "MID") +
    Object.keys(headerFields).reduce(
      (currentHeaderString, key) =>
        currentHeaderString +
        getDataLine(headerFields[key], key),
      ""
    )

  const contentString =
    report.totalCount === 0
      ? getDataLine("NO TRANSACTIONS TO CLEAR", null, true)
      : getDataLine(
          report.fromReceiptNo,
          "From receipt no"
        ) +
        getDataLine(report.toReceiptNo, "To receipt no") +
        getBlankLines(1) +
        getDataLine("SENDING OK", null, true) +
        "SUMMARY: \n" +
        getBlankLines(1) +
        getDoubleDataLine(
          "Sales",
          report.saleCount.toString(),
          formatToMerchantCurrencyString(report.saleAmount)
        ) +
        getDoubleDataLine(
          "Voids",
          report.voidCount.toString(),
          formatToMerchantCurrencyString(report.voidAmount)
        ) +
        getDoubleDataLine(
          "CASHBACK",
          report.cashbackCount.toString(),
          formatToMerchantCurrencyString(
            report.cashbackAmount
          )
        ) +
        getDoubleDataLine(
          "Tips",
          report.gratuityCount.toString(),
          formatToMerchantCurrencyString(
            report.gratuityAmount
          )
        ) +
        getDoubleDataLine(
          "Refunds",
          report.refundCount.toString(),
          formatToMerchantCurrencyString(
            report.refundAmount
          )
        ) +
        getDoubleDataLine(
          "Completions",
          report.completionCount.toString(),
          formatToMerchantCurrencyString(
            report.completionAmount
          )
        ) +
        getDoubleDataLine(
          "TOTAL",
          report.totalCount.toString(),
          formatToMerchantCurrencyString(report.totalAmount)
        ) +
        getDoubleDataLine(
          "Pre-Auth",
          report.preAuthCount.toString(),
          formatToMerchantCurrencyString(
            report.preAuthAmount
          )
        ) +
        getDoubleDataLine(
          "Pre-Auth Top-Up",
          report.preAuthTopUpCount.toString(),
          formatToMerchantCurrencyString(
            report.preAuthTopUpAmount
          )
        ) +
        getDoubleDataLine(
          "Pre-Auth Voids",
          report.preAuthCancelledCount.toString(),
          formatToMerchantCurrencyString(
            report.preAuthCancelledAmount
          )
        )

  const reportString =
    headerString +
    getBlankLines(1) +
    getDataLine("SETTLEMENT", null, true) +
    getBlankLines(1) +
    contentString +
    getBlankLines(1) +
    getDataLine("SENDING OK", null, true) +
    getBlankLines(1) +
    getDataLine("BALANCES VERIFIED", null, true) +
    getDataLine("PLEASE RETAIN RECEIPT", null, true)

  return reportString
}
